var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var CrossLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.854 3.854a.5.5 0 0 0-.708-.708L12 11.293 3.854 3.146a.5.5 0 0 0-.708.708L11.293 12l-8.147 8.146a.5.5 0 0 0 .708.708L12 12.707l8.146 8.147a.5.5 0 0 0 .708-.708L12.707 12l8.147-8.146Z",
    fill: "currentColor"
  }));
});
CrossLg.displayName = "CrossLg";
export default CrossLg;